import { AiModelCatalog, ConfigItem, SystemConfig } from '@/common/model/systemConfig'

export const SystemConfigApiPath = {
  GET_ALL_CONFIGS: '/api/system-config', // GET Get All Configs
  UPDATE_CONFIGS: '/api/system-config', // PUT Update Configs
  GET_W2_CONFIGS: '/api/w2/configs', // GET Get W2 Configs
  GET_UGC_DISPATCH_STATS: '/api/admin/ugc-mail/dispatch-stats', // GET UGCメール分散送信の試算
  GET_AI_MODELS: '/api/system-config/ai-models' // GET AIモデルの選択肢（モデル・プロダクト・既定値）
}

export type SystemConfigApiPath = (typeof SystemConfigApiPath)[keyof typeof SystemConfigApiPath]

export interface GetAllConfigsVars {}

export interface UpdateConfigsVars {
  configs: ConfigItem[]
}

export interface GetW2ConfigsVars {}

export type GetAllConfigsResponse = SystemConfig[]

export interface UpdateConfigsResponse {
  status: string
}

export type GetW2ConfigsResponse = Record<string, string>

/** UGCメール分散送信の試算に使う実数（直近30日の受注から算出） */
export interface UGCDispatchStatsResponse {
  ugc_site_count: number
  daily_avg_per_site: number
  daily_total: number
  top_site_name: string | null
  top_site_daily_avg: number
  batch_limit: number
  interval_minutes: number
}

/** AIモデルの選択肢（SMART_HUB_DEV-159） */
export type GetAiModelsResponse = AiModelCatalog
